import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding-top: ${props => props.theme.spacing.sp24};
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`
